import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import KnowledgeForest from './components/KnowledgeForest';
import LatestContent from './components/LatestContent';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <KnowledgeForest />
      <LatestContent />
      <Footer />
    </div>
  );
}